import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import Dialog from "./ui/Dialog";

const SignUp = ({ isOpen, onClose, phoneNumber }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  // Carry the OTP-verified phone number into the form (set after this modal mounts).
  useEffect(() => {
    if (phoneNumber) {
      setFormData((prev) => ({ ...prev, phoneNumber }));
    }
  }, [phoneNumber]);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");
  const { login } = useAuth();
  const handleClose = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    });
    setErrorMessage("");
    setSuccessMessage("");
    onClose();
  };
  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${BASE_URL}/user/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status?.statusCode === 200) {
        login(result.data.jwtToken, result.data.user);
        window.sessionStorage.setItem("userId", result.data.user.id);
        window.sessionStorage.setItem("refreshToken", result.data.refreshToken);
        window.sessionStorage.setItem(
          "userName",
          result.data.user.firstName + " " + result.data.user.lastName,
        );
        setSuccessMessage(result.status.message);
        setTimeout(() => {
          handleClose();
          navigate("/");
        }, 1000);
      } else {
        setErrorMessage(result.status?.message || "Registration failed.");
      }
    } catch (error) {
      setErrorMessage("Something went wrong.");
    }
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} title="Create account" titleId="signup-title">
      <form onSubmit={handleSubmit} className="fn-auth-form">
        <div>
          <label className="fn-label" htmlFor="signup-first-name">
            First name <span aria-hidden="true" className="fn-auth-req">*</span>
          </label>
          <input
            id="signup-first-name"
            type="text"
            name="firstName"
            autoComplete="given-name"
            value={formData.firstName}
            onChange={handleInputChange}
            className="fn-field"
            required
          />
        </div>

        <div>
          <label className="fn-label" htmlFor="signup-last-name">
            Last name <span aria-hidden="true" className="fn-auth-req">*</span>
          </label>
          <input
            id="signup-last-name"
            type="text"
            name="lastName"
            autoComplete="family-name"
            value={formData.lastName}
            onChange={handleInputChange}
            className="fn-field"
            required
          />
        </div>

        <div>
          <label className="fn-label" htmlFor="signup-email">
            Email <span aria-hidden="true" className="fn-auth-req">*</span>
          </label>
          <input
            id="signup-email"
            type="email"
            name="email"
            autoComplete="email"
            placeholder="name@example.com"
            value={formData.email}
            onChange={handleInputChange}
            className="fn-field"
            required
          />
        </div>

        <div>
          <label className="fn-label" htmlFor="signup-phone">
            Mobile number <span className="fn-auth-muted">(verified)</span>
          </label>
          <input
            id="signup-phone"
            type="text"
            name="phoneNumber"
            autoComplete="tel-national"
            value={formData.phoneNumber}
            onChange={handleInputChange}
            className="fn-field fn-num"
            readOnly
            required
          />
        </div>

        <button className="fn-btn fn-btn-primary fn-btn-block" type="submit">
          Sign up
        </button>
      </form>

      {errorMessage && (
        <p className="fn-error" role="alert">
          {errorMessage}
        </p>
      )}
      {successMessage && (
        <p className="fn-success" role="status">
          {successMessage}
        </p>
      )}
    </Dialog>
  );
};

export default SignUp;
